var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":_vm.title}},[_c('v-icon',{attrs:{"small":"","color":_vm.color}},[_vm._v("mdi-checkbox-blank-circle")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }